export default {
  file: {
    // Downloads a document from the server
    getDocument: {
      type: "get",
      error: {
        404: "Document not found.",
        default: "Error downloading document.",
      },
    },
    /*Params:
    * - #docID: The document ID to retrieve
    * - #dirID: The parent directory for the document
    * - "fileName: The file name that should be retrieved
    */

    // Retrieves a list of documents and directories for patient
    getDocTree: {
      type: "get",
      error: {
        default: "Error loading documents.",
      },
    },
    /*Params:
    * - #patientID?: The patient ID to retrieve documents for
    *  - Defaults to logged in patient
    */

    // Sets document release state
    setDocState: {
      type: "patch",
      success: {
        default: "Successfully set document release state.",
      },
      error: {
        default: "Error setting document release state.",
      },
    },
    /*Params:
    * - #patientID: The patient ID to set release state for
    * - #docID: The document ID to set release state for
    * - =docState: The release state to set
    *  - true: Released
    *  - false: unreleased
    */

    // Uploads a document to the server
    uploadDoc: {
      type: "post",
      success: {
        default: "Successfully uploaded document.",
      },
      error: {
        default: "Error uploading document.",
      },
    },
    /*Params:
    * - #docInfo: The file to upload and its associated info
    */
  },
};